import React from 'react';
import { useTheme } from 'styled-components';
import Icons, { SVGIconProps, IconPath } from '../utils/icons';
/**
* Icon component to render an Icon based on passed iconId
* destructured @param id ID of the icon to be rendered
* destructured @param size Size of the icon to be rendered
* destructured @param color Color of the icon to be rendered
* @returns React FC
*/ 
const Icon: React.FC<any> = ({ id, size = 1, color, config, ...props }: any) => {

	const theme: any = useTheme();

	const dimension = size * ( config?.general?.sizingBase ?? 16 )
	const icon: SVGIconProps | null = React.useMemo(() =>  (id in Icons) ? Icons[id] : null, [id]) ;
	
	if (! icon ) {
		return null; 
	} 

	const { fill: iconDefaultFill, paths } = icon;
	const fill = color ? color : (id in theme?.icons ? theme.icons[id] : (iconDefaultFill ?? 'currentColor') )

	return (
		<svg
			width={dimension}
			height={dimension}
			viewBox={`0 0 ${icon.viewDim} ${'viewDimY' in icon ? icon.viewDimY : icon?.viewDim}`}
			fill={fill}
			xmlns={'http://www.w3.org/2000/svg'}
			{...props}
		>
			{/* Iterating paths */}
			{paths.map((path: IconPath, idx: number) => {
				return (
					// One path markup
					<path
						key={idx}
						{...path}
					/>
				)
			})}
		</svg>
	)
}

export default Icon
